import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=3b0a549d"
import script from "./banks.vue?vue&type=script&lang=js"
export * from "./banks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports